<template>
  <div>
    <v-row justify="center" no-gutters>
      <v-overlay
        absolute
        class="d-flex flex-column text-center"
        opacity="0.35"
        z-index="1"
        :value="mnuCategorias.length === 0"
      >
        <div>
          <v-progress-circular width="2" size="50" color="white" indeterminate>
            <v-icon size="30">mdi-timer-sand</v-icon>
          </v-progress-circular>
        </div>
      </v-overlay>
      <v-btn
        v-for="(item, index) in mnuCategorias"
        :key="index"
        color="primary"
        text
        :to="`/subcategoria/${item.CodigoDiv}/${item.CodigoDep}/${item.Categoria}`"
        @click="idSubCat(item.CodigoDiv, item.CodigoDep, item.Categoria)"
        block
        large
        class="my-2 rounded-sm"
      >
        {{ item.Nombre }}
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  methods: {
    ...mapActions(["consolidadoSCategoria"]),
    ...mapMutations([
      "CLR_DATOS_SUBCAT",
      "CLR_BUSCARMARCA",
      "CLR_BUSCAREPUESTO",
      "GET_BUSCARCAT",
      "CLR_BUSCARSCAT",
      "CLR_BUSCARPROMO",
      "CLR_ERROR_AXIOS",
      "set_varCategorias",
      "CLR_DATOS_SUBCATB",
      "set_changeSubcatF",
      "CLR_DATOS_ART",
      "set_AdPromoF",
    ]),
    idSubCat(Div, Dep, Cat) {
      this.CLR_DATOS_SUBCAT();
      this.CLR_BUSCARPROMO();
      this.CLR_BUSCARSCAT();
      this.CLR_BUSCARMARCA();
      this.CLR_BUSCAREPUESTO();
      this.GET_BUSCARCAT(Cat);
      window.scrollTo(0, 0);
      this.CLR_ERROR_AXIOS();
      this.CLR_DATOS_SUBCATB();

      this.set_changeSubcatF();
      this.CLR_DATOS_ART();
      // this.CLR_PROMO();
      this.set_AdPromoF();
      this.set_varCategorias([Div, Dep, Cat]);
      if (!this.$route.params.codart) this.consolidadoSCategoria({ signal: this.controller.signal })
    },
  },
  destroyed() {
    this.controller.abort();
  },
  data() {
    return {
      controller: new AbortController(),
    }
  },
  computed: {
    ...mapState(["mnuCategorias", "maestro"]),
  },
};
</script>